import { combineReducers } from 'redux';
import app from './reducers';

export default combineReducers(app);
